<template>
  <div>
    <ExportRequestsHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">
      <ExportRequestsFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <ExportRequestsTable
          :countFilterParams="countFilterParams"
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import ExportRequestsHead from "./ExportRequestsHead/ExportRequestsHead";
  import ExportRequestsFilter from "./ExportRequestsFilter/ExportRequestsFilter";
  import ExportRequestsTable from "./ExportRequestsTable/ExportRequestsTable";

  export default {
    name: "ExportRequestsTableAdmin",

    components: {
      ExportRequestsHead,
      ExportRequestsFilter,
      ExportRequestsTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },
    }
  }
</script>

<style scoped>

</style>
